import { Box, Grid, Stack, Typography } from "@mui/material";
import { GridCardContent } from "components/atoms";
import { FormikContextType } from "formik";
import { FC } from "react";
import FormContainer from "./FormContainer";
import FormContent from "./FormContent";

interface IDocumentDetailHeaderProps {
  title: string;
  description?: string;
  isAdd?: boolean;
  formik: FormikContextType<any>;
  loading: boolean;
  onDelete?(): void;
  renderConfirmButton?: React.ReactNode;
}

const DocumentDetailHeader: FC<IDocumentDetailHeaderProps> = (props) => {
  const {
    title,
    description,
    loading,
    formik,
    onDelete,
    renderConfirmButton,
    isAdd,
    children,
  } = props;

  return (
    <GridCardContent sx={{ width: "100%" }}>
      <Box sx={{ p: 2, width: "100%" }}>
        <HeaderTitle title={title} description={description} />
        <FormContainer
          formik={formik}
          loading={loading}
          isAdd={isAdd}
          onDelete={onDelete}
          renderConfirmButton={renderConfirmButton}
        >
          {children}
        </FormContainer>
      </Box>
    </GridCardContent>
  );
};
const HeaderTitle = (props: { title: string; description?: string }) => {
  const { title, description } = props;

  return (
    <Box>
      <Typography
        variant="h2"
        style={{
          color: "black",
        }}
      >
        {title}
      </Typography>
      <Typography
        variant="h1"
        style={{
          color: "black",
        }}
      >
        {description}
      </Typography>
    </Box>
  );
};

export default DocumentDetailHeader;
